import { Icon } from '@chakra-ui/react';
import {
  ESTIMATED_WEIGHT_CONFIRMED_STOCK_COPY,
  ESTIMATED_WEIGHT_PENDING_STOCK_COPY,
  ESTIMATED_WEIGHT_SCALE_ICON_SRC,
  EstimatedWeightOrderDetailStatus as EstimatedWeightOrderDetailStatusValue,
} from '@diamond/sol-buyer/utils';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';

import { InfoHighlightPill } from '../common/info-highlight-pill';

type EstimatedWeightOrderDetailStatusProps = {
  status: EstimatedWeightOrderDetailStatusValue;
};

export function EstimatedWeightOrderDetailStatus({
  status,
}: EstimatedWeightOrderDetailStatusProps) {
  switch (status) {
    case 'pending':
      return (
        <InfoHighlightPill
          iconSrc={ESTIMATED_WEIGHT_SCALE_ICON_SRC}
          size="sm"
          variant="solid"
          whiteSpace="nowrap"
          data-testid="estimated-weight-order-detail-status"
        >
          {ESTIMATED_WEIGHT_PENDING_STOCK_COPY}
        </InfoHighlightPill>
      );
    case 'confirmed':
      return (
        <InfoHighlightPill
          icon={<Icon as={CheckCircleOutline} color="#373F41" />}
          size="sm"
          variant="success"
          whiteSpace="nowrap"
          data-testid="estimated-weight-order-detail-status"
        >
          {ESTIMATED_WEIGHT_CONFIRMED_STOCK_COPY}
        </InfoHighlightPill>
      );
    default: {
      const _exhaustive: never = status;
      return _exhaustive;
    }
  }
}
